/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationRemoteSessionClientsGetDeletePreflight } from "../funcs/organizationRemoteSessionClientsGetDeletePreflight.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { OrganizationClientDeletePreflight } from "../models/components/organizationclientdeletepreflight.js";
import {
  GetOrganizationRemoteSessionClientDeletePreflightRequest,
  GetOrganizationRemoteSessionClientDeletePreflightSecurity,
} from "../models/operations/getorganizationremotesessionclientdeletepreflight.js";
import { unwrapAsync } from "../types/fp.js";
export type OrganizationRemoteSessionClientDeletePreflightQueryData =
  OrganizationClientDeletePreflight;

export function prefetchOrganizationRemoteSessionClientDeletePreflight(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetOrganizationRemoteSessionClientDeletePreflightRequest,
  security?:
    | GetOrganizationRemoteSessionClientDeletePreflightSecurity
    | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationRemoteSessionClientDeletePreflightQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildOrganizationRemoteSessionClientDeletePreflightQuery(
  client$: GramCore,
  request: GetOrganizationRemoteSessionClientDeletePreflightRequest,
  security?:
    | GetOrganizationRemoteSessionClientDeletePreflightSecurity
    | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OrganizationRemoteSessionClientDeletePreflightQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationRemoteSessionClientDeletePreflight({
      id: request.id,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
    }),
    queryFn:
      async function organizationRemoteSessionClientDeletePreflightQueryFn(
        ctx,
      ): Promise<OrganizationRemoteSessionClientDeletePreflightQueryData> {
        const sig = combineSignals(
          ctx.signal,
          options?.signal,
          options?.fetchOptions?.signal,
        );
        const mergedOptions = {
          ...options?.fetchOptions,
          ...options,
          signal: sig,
        };

        return unwrapAsync(organizationRemoteSessionClientsGetDeletePreflight(
          client$,
          request,
          security,
          mergedOptions,
        ));
      },
  };
}

export function queryKeyOrganizationRemoteSessionClientDeletePreflight(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "organizationRemoteSessionClients",
    "getDeletePreflight",
    parameters,
  ];
}
